<script setup>
import {onMounted, ref, computed} from "vue";
import axios from "@/axios";
import {useLanguageStore} from "@/pinia";
import {formatDate} from "@/plugins/dayjs";
const languageStore = useLanguageStore();
const meetingList = ref([]);
const firstVisibleI = ref(0);
const isLoading = ref(true);
const baseColor = [9, 34, 63];
const getData = ()=>{
  isLoading.value = true;
  axios.get("/api/meeting/today")
      .then(s=>{
        meetingList.value= s.data;
      }).catch(e=>{
        console.log(e);
  }).finally(() => {
    isLoading.value = false;
  })
}
const VISIBLE_COUNT = 5; // 한 번에 보이는 아이템 수
const isAtStart = computed(() => firstVisibleI.value === 0);
const isAtEnd = computed(() => {
  if (meetingList.value.length === 0) return true;
  return firstVisibleI.value + VISIBLE_COUNT >= meetingList.value.length;
});

const moveRight = () => {
  const maxIndex = Math.max(0, meetingList.value.length - VISIBLE_COUNT);
  if (firstVisibleI.value < maxIndex) {
    firstVisibleI.value = Math.min(firstVisibleI.value + VISIBLE_COUNT, maxIndex);
  }
};

const moveLeft = () => {
  if (firstVisibleI.value > 0) {
    firstVisibleI.value = Math.max(0, firstVisibleI.value - VISIBLE_COUNT);
  }
};

const totalPages = computed(() => Math.ceil(meetingList.value.length / VISIBLE_COUNT));
const currentPage = computed(() => Math.floor(firstVisibleI.value / VISIBLE_COUNT) + 1);

const getColor = (i) => {
  const absIndex = firstVisibleI.value + i;
  const lightness = 1 - (0.5 * absIndex / Math.max(meetingList.value.length - 1, 1));
  const [r, g, b] = baseColor;
  return `rgba(${r}, ${g}, ${b}, ${lightness})`;
};
onMounted(()=>{
  getData()
})

</script>

<template>
  <div class="meetingListArea">
    <div class="meetingListHeader">
      <div class="meetingListTitle">
        {{languageStore.get('todayLiveSchedule')}}
      </div>
      <div v-if="totalPages > 1" class="pageIndicator">
        {{ currentPage }} / {{ totalPages }}
      </div>
    </div>
    <template v-if="isLoading">
      <div class="loadingArea">
        <v-progress-circular indeterminate color="#052C65" size="24"></v-progress-circular>
      </div>
    </template>
    <template v-else-if="meetingList.length > 0">
      <div class="meeting">
        <div v-if="!isAtStart">
          <v-icon size="50"
                  class="d-flex align-items-center arrowIcon icon"
                  @click="moveLeft"
          >mdi-chevron-left</v-icon>
        </div>
        <div v-else class="d-flex" style="width: 50px;"></div>

        <div class="meetingLists">
          <template v-for="(meeting,i) in meetingList.slice(firstVisibleI, firstVisibleI + VISIBLE_COUNT)" :key="i">
            <div class="meetingList" :style="{backgroundColor: getColor(i)}">
              <div class="meetingDateTime">{{formatDate(meeting.meetingPreDt, 'HH:mm')}}</div>
              <div class="meetingName">{{meeting.meetingType.codeNm}}</div>
              <div>{{meeting.meetingLocation.codeNm }}</div>
            </div>
          </template>
        </div>

        <div v-if="!isAtEnd">
          <v-icon size="50"
                  class="d-flex align-items-center arrowIcon"
                  @click="moveRight">mdi-chevron-right</v-icon>
        </div>
        <div v-else class="d-flex" style="width: 50px;"></div>
      </div>
    </template>
    <template v-else>
      <div class="noSchedule">
        <v-icon size="20" class="mr-2">mdi-calendar-blank-outline</v-icon>
        {{ languageStore.get('noLiveScheduleToday') }}
      </div>
    </template>
  </div>
</template>

<style scoped>
.meetingListArea{
  display: flex;
  background: #FFFFFF;
  height: 14vh;
  width: 90%;
  flex-direction: column;
}
.meeting{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.meetingListHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 40px 10px 40px;
}
.meetingListTitle{
  font-weight: bold;
}
.pageIndicator {
  font-size: 13px;
  color: #6c757d;
}
.meetingList{
  height: 10vh;
  width: 15vw;
  //background-color: #09223F;
  border-right: 1px solid #C7C7C7;
  padding: 10px;
  min-width: 15vw;
}
.meetingLists{
  overflow: scroll;
  display: flex;
  justify-content: flex-start;
  width: 90%;
  color: white;
}
.meetingLists::-webkit-scrollbar {
  display: none;
}
.noData {
  margin-top: 25px;
  padding-left: 40px;
  color:red;
}
.arrowIcon{
  cursor:pointer;
  background-color: #052C65;
  color: white;
  border-radius: 50%;
  padding: 5px;
  transition: all 0.2s ease;
}
.arrowIcon:hover {
  background-color: #09223F;
  transform: scale(1.1);
}
.noSchedule {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6c757d;
  font-size: 14px;
}
.loadingArea {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>